const menuWrapper = document.querySelector("[data-lang-container]");
const langMenu    = document.querySelector("[data-lang-menu]");
const minWidth    = langMenu ? parseInt(langMenu.dataset.breakpoint) : 0;

export function initNavigationLang() {
	/**
	 * @title Menu Trigger
	 **/
	const menuTrigger = document.querySelector("[data-lang-open]");
	const menuClose = document.querySelectorAll("[data-lang-close]");

	if (langMenu) {
		// Check the trigger exists
		if (menuTrigger) {
			menuTrigger.addEventListener("click", menuButtonHandler.bind(event, "open"));
		}

		// Check the close button exists
		if (menuClose) {
			menuClose.forEach(function (close) {
				close.addEventListener("click", menuButtonHandler.bind(event, "close"));
			});
		}
	}


	/**
	 * @title Menu Button Handler
	 * @description This will control the opening & closing of the menu.
	 * @param {string} action - open/close
	 */
	function menuButtonHandler(action) {
		switch (action) {
			case "open":
				menuWrapper.setAttribute("data-lang-container", "open");
				openNavigation(null, null, langMenu, null, true);
				menuTrigger.setAttribute("aria-expanded", "true");
				break;
			case "close":
				menuWrapper.setAttribute("data-lang-container", "closed");
				closeNavigation();
				menuTrigger.setAttribute("aria-expanded", "false");
				break;
			default:
				return;
		}
	}


	/**
	 * @title Open Navigation
	 * @description This will open up the mobile menu
	 * @param {object} elementToOpen - The submenu/menu to be opened
	 * @param {object} elementToClose - The submenu/menu to be closed
	 * @param {bool} childLevel - Whether or not we're opening a child submenu
	 * @param {object} focusElement - If there should be a certain focusElement
	 */
	function openNavigation(
		parentNode,
		parentLink,
		elementToOpen,
		elementToClose,
		childLevel,
		focusElement,
	) {
		if (elementToOpen) {
			const openLink = elementToOpen.getElementsByTagName("a")[0];
			// Make sure the body can't scroll when the mobile menu is open
			document.body.setAttribute("data-lang-open", "");

			// Our version of a toggle for the CSS
			const data = elementToOpen.getAttribute("data-lang");
			if ((data && data === "open") || (data && data === "child-open" && childLevel !== false)) {
				elementToOpen.setAttribute("data-lang", "");
				elementToOpen.setAttribute("aria-hidden", "true");
				if (parentNode && parentLink) {
					parentNode.setAttribute("data-nav-item-children", "");
					parentLink.setAttribute("aria-expanded", "false");
				}
				document.body.removeAttribute("data-lang-open");
			} else {
				elementToOpen.setAttribute("data-lang", "open");
				elementToOpen.setAttribute("aria-hidden", "false");
				if (parentNode && parentLink) {
					parentNode.setAttribute("data-nav-item-children", "open");
					parentLink.setAttribute("aria-expanded", "true");
				}
			}

			if (elementToClose && typeof elementToClose !== "undefined") {
				if (typeof childLevel !== "undefined" && childLevel === true) {
					elementToClose.setAttribute("data-lang", "child-open");
				} else {
					elementToClose.setAttribute("data-lang", "closed");
				}
			}
		}
	}


	/**
	 * @title Close Entire Navigation
	 * @description This will check the transitions on the main menu, and then run a function to close the main menu
	 */
	function closeNavigation() {
		document.body.removeAttribute("data-lang-open");
		// Close the main menu
		langMenu.setAttribute("data-lang", "");

		const style = window.getComputedStyle(langMenu, null).getPropertyValue("transition");

		// If there is no transition
		if (style === "all 0s ease 0s") {
			closeMenu();
		} else {
			// If a transition is applied, we need to close the menu once it's finished
			langMenu.addEventListener(
				"transitionend",
				function (event) {
					closeMenu();
				},
				{
					once: true,
				},
			);
		}
	}


	/**
	 * @title Closing Menu
	 * @description This will close the submenus & mobile menu
	 */
	function closeMenu() {
		const firstLevelMenu = document.querySelector('[data-lang-id="1"]');
		const subMenus = document.querySelectorAll("[data-submenu]");
		const menuLinks = langMenu.querySelectorAll("[aria-expanded='true']");

		// Set the initial menu back to original state
		firstLevelMenu.setAttribute("data-lang", "open");
		firstLevelMenu.setAttribute("aria-hidden", "false");

		// Close all submenus
		if (subMenus.length) {
			subMenus.forEach(function (element) {
				element.setAttribute("data-lang", "");
				element.setAttribute("aria-hidden", "true");
			});
		}

		// Change all link attributes
		if (menuLinks.length) {
			menuLinks.forEach(function (element) {
				element.setAttribute("aria-expanded", "false");
			});
		}
	}

	/**
	 * @title Keyboard Direction
	 * @description This will dictate which direction you move on the menu based on keys
	 * @param {object} element
	 * @param {string} direction
	 */
	function keyboardDirection(element, direction) {
		let previousElement = element.previousElementSibling;
		const nextElement = element.nextElementSibling;
		const submenuTransition = langMenu.querySelector("[data-submenu-transition]").dataset
			.submenuTransition;
		const isSubmenu = element.closest(["[data-submenu]"]);

		switch (direction) {
			case "left":
				if (previousElement) {
					if (
						previousElement.hasAttribute("data-nav-item") &&
						previousElement.getElementsByTagName("span") &&
						!previousElement.getElementsByTagName("a")[0]
					) {
						previousElement = previousElement.previousElementSibling;
					}
					if (previousElement.hasAttribute("data-nav-item")) {
						previousElement.getElementsByTagName("a")[0].focus();
					}
					if (previousElement.hasAttribute("data-menu-current")) {
						previousElement.focus();
					}
				}
				break;
			case "right":
				if (nextElement && nextElement.hasAttribute("data-nav-item")) {
					nextElement.getElementsByTagName("a")[0].focus();
				}
				break;
			case "down":
				if (
					element.hasAttribute("data-nav-item-children") &&
					element.getAttribute("data-nav-item-children") === "open" &&
					window.matchMedia(`(min-width: ${minWidth}px)`).matches
				) {
					const subMenu = element.querySelector("[data-submenu]");
					const firstResult = subMenu.getElementsByTagName("a")[0];

					firstResult.focus();
				} else if (nextElement && nextElement.hasAttribute("data-nav-item")) {
					let nextLink = nextElement.getElementsByTagName("a")[0];
					const nextHeading = nextElement.getElementsByTagName("span");
					if (nextLink) {
						nextLink.focus();
					} else if (nextHeading && nextElement.nextElementSibling) {
						nextLink = nextElement.nextElementSibling.getElementsByTagName("a")[0];
						if (nextLink) {
							nextLink.focus();
						}
					}
				}
				break;
			case "up":
				if (previousElement) {
					if (
						previousElement.hasAttribute("data-nav-item") &&
						previousElement.getElementsByTagName("span") &&
						!previousElement.getElementsByTagName("a")[0]
					) {
						previousElement = previousElement.previousElementSibling;
					}
					if (
						previousElement &&
						previousElement.hasAttribute("data-nav-item") &&
						previousElement.getElementsByTagName("a")[0]
					) {
						previousElement.getElementsByTagName("a")[0].focus();
					}
					if (previousElement && previousElement.hasAttribute("data-menu-current")) {
						previousElement.focus();
					}
					if (previousElement && previousElement.tagName === "BUTTON") {
						closeSubMenu(isSubmenu, isSubmenu.dataset.menuId);
					}
				}
				break;
			case "tab":
				if (
					submenuTransition == "slide" &&
					window.matchMedia(`(max-width: ${minWidth - 1}px)`).matches &&
					!nextElement &&
					isSubmenu
				) {
					isSubmenu.addEventListener(
						"transitionend",
						function (event) {
							const active = document.activeElement;
							openNavigation(
								element,
								element.getElementsByTagName("a")[0],
								active.closest(["[data-menu]"]),
								isSubmenu,
								false,
								active,
							);
						},
						{
							once: true,
						},
					);
				} else if (nextElement && nextElement.hasAttribute("data-nav-item")) {
					event.preventDefault();
					nextElement.getElementsByTagName("a")[0].focus();
				}
				break;
			default:
				return;
		}
	}

	/**
	 * @title Throttle
	 * @description Custom Throttle function
	 **/
	function throttle(action, timeFrame) {
		let lastTime = 0;
		return function (...args) {
			var now = new Date();
			if (now - lastTime >= timeFrame) {
				action(...args);
				lastTime = now;
			}
		};
	}
}
